import React from 'react';
import PCJournalsTable from './PCJournalsTable';

export default function PCJournalGroups({ journals = [], setJournals }) {
  const groupList = [
    { groupId: 'A.1', name: 'Biaya Resources' },
    { groupId: 'A.2', name: 'Biaya Operasional' },
    { groupId: 'A.3', name: 'Biaya Instalasi/Jasa' },
    { groupId: 'A.4', name: 'Biaya Splicing dan Terminasi' },
    { groupId: 'A.5.1', name: 'Biaya Material - By HO' },
    { groupId: 'A.5.2', name: 'Biaya Material - By PROJECT' },
    { groupId: 'A.6', name: 'Perijinan dan Akomodasi' },
    { groupId: 'A.7.1', name: 'Biaya SITAC CANVASSING' },
    { groupId: 'A.7.2', name: 'Biaya ENGINEERING DESIGN' },
  ];

  // ✅ DERIVED STATE (TIDAK PAKAI useState / useEffect)
  const groups = groupList.map((g) => ({
    ...g,
    rows: journals.filter((j) => j.groupId === g.groupId),
  }));

  const updateGroupRows = (groupId, newRows) => {
    const others = journals.filter((j) => j.groupId !== groupId);

    const merged = [...others, ...newRows.map((r) => ({ ...r, groupId }))];

    setJournals(merged);
  };

  return (
    <div>
      {groups.map((g) => (
        <div key={g.groupId} className="mb-4 border rounded p-3 bg-white">
          <h6 className="fw-bold">
            {g.groupId} - {g.name}
          </h6>

          <PCJournalsTable
            groupId={g.groupId}
            journals={g.rows}
            setJournals={(rows) => updateGroupRows(g.groupId, rows)}
          />
        </div>
      ))}
    </div>
  );
}
